import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ServicePropertiesControllerService } from "../../../../services/service-controller/service-properties-controller.service";
import { GuideFormControllerService } from "../../../../services/form-controller/guide-form-controller.service";
import { ApplicantFormControllerService } from "../../../../services/form-controller/applicant-form-controller.service";
import { PaymentFormControllerService } from "../../../../services/form-controller/payment-form-controller.service";
import { SendFileFormControllerService } from "../../../../services/form-controller/sendfile-form-controller.service";
import { DocumentFormControllerService } from "../../../../services/form-controller/document-form-controller.service";
import {
  DeterminantControllerService,
} from "../../../../services/registration-controller/determinant-controller.service";
import { Store } from "../../../../services/store.service";
import { RecoverOrphanConfig } from "../../../../models/recover-orphan-config";

@Component({
  selector: "app-apfiletabs",
  templateUrl: "./application-file-tabs.html",
  styleUrls: ["./application-file-tabs.scss"],
  providers: [ServicePropertiesControllerService,
    GuideFormControllerService,
    ApplicantFormControllerService,
    DocumentFormControllerService,
    PaymentFormControllerService,
    SendFileFormControllerService,
  ],
})
export class ApplicationFileTabsComponent implements OnChanges {

  @Input() public serviceId: string;
  @Input() public serviceName: string;
  @Input() public form: any;
  @Input() public formName: string = "";
  @Input() public customClass: string = "";
  @Output() public activateFormEvent = new EventEmitter();
  @Output() public change = new EventEmitter();
  @Output() public openFormBugsDrawer = new EventEmitter<{ formId: string; formName: string }>();

  public activateForm() {
    if (this.form) {
      this.activateFormEvent.emit(this.form.active);
    }
  }

  @Input() public applicationFileData: any[];
  @Input() public determinantMapById: { [key: string]: string };
  @Input() public debugMode: boolean = false;
  @Input() public debugErrors: RecoverOrphanConfig[] = [];
  public errorCounts: { [key: string]: number } = {};

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.debugErrors || changes.debugMode) {
      this.calculateErrorCounts();
    }
  }

  private calculateErrorCounts() {
    this.errorCounts = {};
    if (this.debugErrors && this.debugErrors.length) {
      this.debugErrors.forEach(error => {
        if (error.parentId) {
          this.errorCounts[error.parentId] = (this.errorCounts[error.parentId] || 0) + 1;
        }
      });
    }
  }

  public getErrorsForForm(formId: string): number {
    return this.errorCounts[formId] || 0;
  }

  public showOldGuide: boolean = false;
  public guide: any;
  public guideFormId: string;
  public guideForm: any;

  // hack - angular does not support routerlinks properly

  constructor(private activatedRoute: ActivatedRoute,
    private guideFormControllerService: GuideFormControllerService,
    private applicantFormControllerService: ApplicantFormControllerService,
    private paymentFormControllerService: PaymentFormControllerService,
    private sendFileFormControllerService: SendFileFormControllerService,
    private documentFormControllerService: DocumentFormControllerService,
    private determinantService: DeterminantControllerService,
    private store: Store) { }

  private checkFormChange(item): void {
    if (this.formName === item.name) {
      this.change.emit(item.form.active);
    }
  }

  public toggleForm(item): void {
    item.form.active = !item.form.active;
    switch (item.name) {
      case "GuideForm": {
        this.guideFormControllerService.activateGuideForm(item.form.id, item.form.active).subscribe();
        this.checkFormChange(item);
        break;
      }
      case "ApplicantForm": {
        this.applicantFormControllerService.activateApplicantForm(item.form.id, item.form.active).subscribe();
        this.checkFormChange(item);
        break;
      }
      case "DocumentForm": {
        this.documentFormControllerService.activateDocumentForm(item.form.id, item.form.active).subscribe();
        this.checkFormChange(item);
        break;
      }
      case "PaymentForm": {
        this.paymentFormControllerService.activatePaymentForm(item.form.id, item.form.active).subscribe();
        this.checkFormChange(item);
        break;
      }
      case "SendPageForm": {
        this.sendFileFormControllerService.activateSendFileForm(item.form.id, item.form.active).subscribe();
        this.checkFormChange(item);
        break;
      }
      default:
        break;
    }
  }

  public roleDeterminants(roleDets): string {
    let detNamesList = "";
    if (roleDets !== null && roleDets !== "") {
      if (typeof roleDets === "string") { roleDets = JSON.parse(roleDets); }
      roleDets.forEach((det) => {
        det.items.forEach((indet, j) => {
          const detName = this.determinantMapById && this.determinantMapById[indet.determinantId];
          if (detNamesList !== "") {
            detNamesList += "\n";
          }
          detNamesList += (j + 1) + ". " + detName;
        });
      });
    }
    return detNamesList;
  }

  public onBadgeClick(formId: string, formName: string): void {
    this.openFormBugsDrawer.emit({ formId, formName });
  }

  public hasDeterminants(jDet): boolean {
    if (jDet === undefined || jDet === null || jDet === "") {
      return false;
    }
    if (typeof jDet === "string") {
      try {
        const parsed = JSON.parse(jDet);
        return Array.isArray(parsed) && parsed[0]?.items?.length > 0;
      } catch {
        return false;
      }
    }
    return jDet[0]?.items?.length > 0;
  }

}
